import assert from '../../core/util/assert';
import type { StockStatuses } from '../types';
import getDisplayedQuantity from './getDisplayedQuantity';
import getMaxDisplayedQuantity from './getMaxDisplayedQuantity';
import { primaryStockMessageKey } from './stockMessageKeys';

const getAvailableStatusMessage = (
    availableStatus: {
        status: StockStatuses;
        quantity?: number;
        date?: string;
    },
    sku: string,
    desiredQuantity: number
) => {
    const { quantity, status } = availableStatus;
    assert(quantity, 'quantity is required.');
    const maxDisplayedQuantity = getMaxDisplayedQuantity(sku);

    return {
        messageId: primaryStockMessageKey[status],
        values: {
            quantity: getDisplayedQuantity({
                quantity,
                desiredQuantity,
                maxDisplayedQuantity,
            }),
        },
    };
};

export default getAvailableStatusMessage;
